var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"question-title u-typography-helvetica u-text u-text--s"},[_c('span',{staticClass:"question-title__text"},[_vm._t("default")],2),(_vm.hint)?_c('info-tooltip',{staticClass:"question-title__tooltip-icon",attrs:{"hint":_vm.hint}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }